import { useGate, useStore } from 'effector-react'
import { Outlet } from 'react-router-dom'
import { protectedUnAuthModel } from '~/entities/ProtectedUnAuth'
import { useTaxiparkQueryParams } from '~/shared/lib/useTaxiparkQueryParams'
import { ProgressBlock } from '~/shared/ui/Loaders'

export function ProtectedBookingCarsUnAuthPage() {
  const { xTaxiparkKeyQuery } = useTaxiparkQueryParams()

  useGate(protectedUnAuthModel.Gate, {
    xTaxiparkKey: xTaxiparkKeyQuery,
  })

  const interceptorId = useStore(protectedUnAuthModel.$interceptorId)

  if (xTaxiparkKeyQuery && !interceptorId)
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ProgressBlock />
      </div>
    )

  return <Outlet />
}
